export default __webpack_public_path__ + "d45fd63897c7096673bb0f7706f9d8f6.png";